<template>
  <div>
    <footer>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-3 col-sm-4 col-xs-6">
            <h5>FOR JOB SEEKERS</h5>
            <ul>
              <li><a href="https://www.theincircle.com/">Search Jobs</a></li>
              <li>
                <a href="https://www.theincircle.com/create-profile"
                  >Create Profile</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/post-resume"
                  >Upload Resume
                </a>
              </li>
              <li>
                <a href="https://www.theincircle.com/employee-register"
                  >Candidates Register
                </a>
              </li>
              <li>
                <a href="https://www.theincircle.com/fresher-jobs"
                  >Jobs For Fresher</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/latest-jobs"
                  >Jobs for Experienced</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/job-alert"
                  >Create Job Alerts
                </a>
              </li>
              <li>
                <a href="https://www.theincircle.com/employee-login"
                  >Candidates Login</a
                >
              </li>
            </ul>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-6">
            <h5>JOB BY TYPE</h5>

            <ul>
              <li>
                <a href="https://www.theincircle.com/latest-jobs"
                  >Latest Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/mncjobs-in-companies"
                  >MNC Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/fresher-jobs"
                  >Fresher Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs-by-designation"
                  >Jobs By Skill</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs-by-location"
                  >Jobs By City</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/govt-job"
                  >Government Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/latest-jobs"
                  >Jobs By Role</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/industry-list"
                  >Job By Industry</a
                >
              </li>
            </ul>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-6">
            <h5>JOBS in Industrial Area</h5>
            <ul>
              <li>
                <a href="https://www.theincircle.com/jobs/manufacturing-jobs"
                  >Manufacturing Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/production-jobs"
                  >Production Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/construction-jobs"
                  >Construction Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/maintenance-jobs"
                  >Maintenance Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/labour-jobs"
                  >Labors Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/bpo-jobs">BPO Jobs</a>
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/technician-jobs"
                  >Technician Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/cook-chef-jobs"
                  >Cook Chef Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/delivery-jobs"
                  >Delivery Workers Jobs</a
                >
              </li>
            </ul>
          </div>

          <div class="col-md-2 col-sm-4 col-xs-6">
            <h5>JOBS in Business Corporate</h5>
            <ul>
              <li>
                <a href="https://www.theincircle.com/jobs/sales-marketing-jobs"
                  >Sales Marketing Jobs</a
                >
              </li>

              <li>
                <a href="https://www.theincircle.com/jobs/accounting-jobs"
                  >Accounts Finance Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/logistic-executive-jobs"
                  >Logistics Supply Chain</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/engineering-jobs"
                  >Engineering Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/it-software-jobs"
                  >IT Software Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/bpo-telecaller-jobs"
                  >BPO Telecaller Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/seo-jobs"
                  >SEO Digital Marketing Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/graphic-web-designer-jobs"
                  >Graphic Web Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/hr-admin-jobs"
                  >HR Admin Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/computer-data-entry-jobs"
                  >Computer Data Entry Jobs</a
                >
              </li>
            </ul>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-6">
            <h5>JOB BY CITY</h5>
            <ul>
              <li><a href="#">Jobs in Delhi</a></li>
              <li><a href="#">Jobs in Bangalore</a></li>
              <li><a href="#">Jobs in Mumbai</a></li>
              <li><a href="#">Jobs in Kolkata</a></li>
              <li><a href="#">Jobs in Chennai</a></li>
              <li><a href="#">Jobs In Lucknow</a></li>
              <li><a href="#">Jobs In Pune</a></li>
              <li><a href="#">Jobs In Hyderabad </a></li>
              <li><a href="#">Jobs In Noida</a></li>
              <li><a href="#">Jobs Gurugram</a></li>
            </ul>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-6">
            <h5>Job for White Collared/Grey Collared(Designation)</h5>
            <ul>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/software-developer-jobs"
                  >Software Developer Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/digital-marketing-jobs"
                  >Digital Marketing Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/web-designer-jobs"
                  >Web Designing Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/receptionist-jobs"
                  >Receptionist Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/business-development-jobs"
                  >Business Development Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/education-counselor-jobs"
                  >Education Counselor Jobs</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/hr-executive-jobs"
                  >Hr Executive Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/personal-assistant-jobs"
                  >Personal Assistant Jobs
                </a>
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/marketing-executive-jobs"
                  >Marketing Executive Jobs</a
                >
              </li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/telemarketing-executive-jobs"
                  >Telemarketing Jobs</a
                >
              </li>
            </ul>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-6">
            <h5>Jobs for Blue collared (Skills)</h5>
            <ul>
              <li><a href="#">Machine operators</a></li>
              <li><a href="#">Tailor</a></li>
              <li><a href="#">Carpenter</a></li>
              <li><a href="#">Plumber</a></li>
              <li><a href="#">Helper</a></li>
              <li>
                <a
                  href="https://www.theincircle.com/jobs/factory-supervisor-jobs"
                  >Factory Supervisor</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/factory-worker-jobs"
                  >Factory Workers</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/fitter-welder-jobs"
                  >Fitter Welder
                </a>
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/hvac-technician-jobs"
                  >Technician
                </a>
              </li>
              <li>
                <a href="https://www.theincircle.com/jobs/mechanic-jobs"
                  >Mechanic
                </a>
              </li>
            </ul>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-6">
            <h5>FOR EMPLOYERS</h5>
            <ul>
              <li><a href="#">Post Jobs </a></li>
              <li>
                <a href="https://www.theincircle.com/employerzone/post-job"
                  >EMPLOYERS Login
                </a>
              </li>
              <li>
                <a href="https://www.theincircle.com/employerzone/"
                  >EMPLOYERS Register
                </a>
              </li>
              <li>
                <a href="https://www.theincircle.com/hireemployee"
                  >Hire Staff</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/find-resume"
                  >Find Resume</a
                >
              </li>
              <li>
                <a href="https://www.theincircle.com/plans">Hiring Plans</a>
              </li>
              <li>
                <a href="https://www.theincircle.com/database">Database Plan</a>
              </li>
              <!-- <li>
                <a href="https://www.theincircle.com/consultant"
                  >Consultant Plan
                </a>
              </li> -->
              <li>
                <a href="https://www.theincircle.com/employerzone/paid-post-job"
                  >Job Posting Plan</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>

    <div class="steacky">
      <div class="text-center connect">
        <h5>Connect with Us</h5>

        <ul class="list-inline social-links">
          <li class="social-1">
            <a
              class="facebook"
              href="https://www.facebook.com/TheIncircle"
              target="_blank"
            >
              <i class="fa fa-facebook" aria-hidden="true"></i>
            </a>
          </li>
          <li class="social-1">
            <a
              class="twitter"
              href="https://twitter.com/theincircle"
              target="_blank"
            >
              <i class="fa fa-twitter" aria-hidden="true"></i>
            </a>
          </li>

          <li class="social-1">
            <a
              class="linkedin"
              href="https://www.linkedin.com/company/the-incircle"
              target="_blank"
            >
              <i class="fa fa-linkedin" aria-hidden="true"></i>
            </a>
          </li>

          <li class="social-1">
            <a
              class="insta"
              href="https://www.instagram.com/theincirclejobs"
              target="_blank"
            >
              <i class="fa fa-instagram" aria-hidden="true"></i>
            </a>
          </li>
          <li class="social-1">
            <a
              class="pinterest"
              href="https://www.pinterest.com/incirclethe"
              target="_blank"
            >
              <i class="fa fa-pinterest-p" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>

      <div class="footer-link text-center">
        <a href="/#/about-us" >
          About Us
        </a>
        |
        <a href="https://www.theincircle.com/contactus" target="_blank">
          Contact Us
        </a>
        |
        <a href="https://www.theincircle.com/blog" target="_blank"> Blog </a> |
        <a href="https://www.theincircle.com/faq" target="_blank"> FAQ </a> |
        <a href="https://www.theincircle.com/help" target="_blank"> Help </a>|
        <a href="https://www.theincircle.com/privacy" target="_blank">
          Privacy Policy
        </a>
        |
        <a href="https://www.theincircle.com/terms" target="_blank"> Terms </a>
      </div>
      <div class="footer-note text-center">
        © 2024 TAGGER TECHNOLOGIES LLP, All Rights Reserved.
      </div>
    </div><div class="modal" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">

        <div class="modal-body text-center">

          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <a class="hidden-xs hidden-sm" href="/" title="The incircle" data-toggle="tooltip"><img src="@/assets/images/logo.gif"
              width="100px"></a>
        </div>
        <div class="text-center hire-banner">
          <a href=""><span class="rounded-circle"><i class="fa fa-street-view"></i></span> Hire Staff</a>


          <a href=""><span class="rounded-circle"><i class="fa fa-address-card"></i></span>Find Jobs</a>

          <br /> <br />
        </div>
      </div>

    </div>
  </div>
  
  <div class="add-to-home">
    <button type="button" class="close text-right pr-1 close-add-to-home" onclick="parentNode.remove()">
      <span aria-hidden="true">&times;</span>
    </button>

    <div class="text-center"> <a href="#;">Add to home (Jobs Alert) <i class="fa  fa-angle-right"></i></a></div>
  </div>

  </div>
</template>

<script>
export default {
  name: "FooterEmployee",
};
</script>
<style scoped lang="scss">

footer ul li a:hover {
  text-decoration: underline;
}
a:hover {
  color: #0056b3;
  text-decoration: underline;
}
footer ul li a {
  font-size: 14px;
  line-height: 18px;
}
footer h5, footer ul li a {
  color: #555452;
}
a {
  color: #007bff;
  text-decoration: none;
  background-color: transparent;
}
.footer-link {
  color: #ccc;
}

.footer-link a {
  padding: 0 10px;
  font-size: 12px;
  font-weight: 400;
  color: #555;
}
</style>
